import { Navigate } from "react-router";
import { useBreakpoint } from "@/hooks/use-breakpoint";
import { SettingsMobileMenu } from "./settings-mobile-menu";

// `/:workspaceId/settings` index: mobile shows the menu (master view),
// desktop falls through to the General section so the split-pane layout
// always has content on the right pane (preserves pre-mobile behaviour).
export function SettingsIndexPage() {
  const { isAtLeast } = useBreakpoint();
  if (isAtLeast("md")) return <Navigate to="general" replace />;
  return <SettingsMobileMenu />;
}
